import { LogoSGOSTU } from '../../common/Logos/Logo-SGOSTU';
import Navigation from './Navigation/Navigation';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { changeLanguage } from 'redux/language';
import './Header.css';
import { useLanguage } from 'hooks/useLanguage';

export default function Header() {
  const [openSideMenu, setOpenSideMenu] = useState(false);
  const hamburgerRef = useRef(null);
  const dispatch = useDispatch();
  const language = useLanguage();

  // Шапка ущільнюється, щойно сторінка зрушила з місця. Спостерігач по сентинелу
  // замість слухача scroll — ADR-0008.
  const [isScrolled, setIsScrolled] = useState(false);
  const sentinelRef = useRef(null);

  useEffect(() => {
    const node = sentinelRef.current;
    if (!node || typeof IntersectionObserver === 'undefined') return undefined;

    const observer = new IntersectionObserver(([entry]) => setIsScrolled(!entry.isIntersecting), { threshold: 1 });
    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  function switchLanguage(next) {
    if (next === language) return;
    // Перезавантаження сторінки тут більше немає: мова лежить у сховищі, тож
    // інтерфейс перемальовується сам, а розділи CMS перезапитуються іншою
    // локаллю (useContent).
    dispatch(changeLanguage(next));
  }

  return (
    <>
      <span ref={sentinelRef} className='header-sentinel' aria-hidden='true' />

      <header className={`header ${isScrolled ? 'is-scrolled' : ''} ${openSideMenu ? 'is-menu-open' : ''}`}>
        <div className='container header__wrapper'>
          <div className='header__row'>
            <button
              type='button'
              ref={hamburgerRef}
              className='hamburger'
              aria-expanded={openSideMenu}
              aria-controls='primary-navigation'
              aria-label={
                openSideMenu
                  ? language === 'en'
                    ? 'Close menu'
                    : 'Закрити меню'
                  : language === 'en'
                  ? 'Open menu'
                  : 'Відкрити меню'
              }
              onClick={() => setOpenSideMenu((open) => !open)}
            >
              <span className='ham-line' />
              <span className='ham-line' />
              <span className='ham-line' />
            </button>

            <a href='/' className='name'>
              <LogoSGOSTU classname='header-logo' />
              <span className='company-name'>{language === 'en' ? 'SGOSTU' : 'СГОСТУ'}</span>
              <span className='company-full'>
                {language === 'en'
                  ? 'Dancesport public organisations union of Ukraine'
                  : 'Спілка громадських організацій спортивного танцю України'}
              </span>
            </a>
          </div>

          <div className='language' role='group' aria-label={language === 'en' ? 'Language' : 'Мова'}>
            <button
              type='button'
              className={`language-btn ${language === 'ua' ? 'is-active' : ''}`}
              aria-pressed={language === 'ua'}
              onClick={() => switchLanguage('ua')}
            >
              UA
            </button>
            <span className='language-sep' aria-hidden='true' />
            <button
              type='button'
              className={`language-btn ${language === 'en' ? 'is-active' : ''}`}
              aria-pressed={language === 'en'}
              onClick={() => switchLanguage('en')}
            >
              EN
            </button>
          </div>
        </div>
      </header>

      <Navigation openSideMenu={openSideMenu} setOpenSideMenu={setOpenSideMenu} returnFocusRef={hamburgerRef} />
    </>
  );
}
